module.exports = __webpack_public_path__ + "img/logo_circos_do_brasil.5452805a.png";